import { DialogActions, DialogContent, Typography } from '@mui/material';
import React from 'react';
import type { AxiosError } from 'axios';
import CbButton from '../../../components/Buttons/CbButton';
import { deleteConnection } from '../ConnectorService';
import { PubSub } from '../../../utils/eventUtils';
import useNotifications from '../../../_lib/notifications/useNotifications';

interface DeleteQuoteModalProps {
  data: {
    name: string;
    connection_id: string;
    organization_id: string;
    onDeleteSuccess?: () => void;
  };
  close: () => void;
}

const DeleteConnectorModal = ({
  data: modalProps,
  close,
}: DeleteQuoteModalProps) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const notifications = useNotifications();

  const handleDeleteConnector = () => {
    setIsSubmitting(true);
    deleteConnection({ id: modalProps.connection_id })
      .then(() => {
        notifications.success('Connection deleted successfully.');
        PubSub.publish('connector-page-refetch', true);
        close();

        if (typeof modalProps.onDeleteSuccess == 'function') {
          modalProps.onDeleteSuccess();
        }
      })
      .catch((error: Error | AxiosError) => {
        notifications.error(`Connection deleted successfully.: ${error}`);
      })
      .finally(() => setIsSubmitting(false));
  };

  return (
    <>
      <DialogContent style={{ padding: '2rem' }}>
        <Typography
          variant="body1"
          color="primary"
          style={{ textAlign: 'center', margin: '0 auto' }}
        >
          Are you sure you want to delete connection{' '}
          <strong>{modalProps.name}</strong>?
        </Typography>
      </DialogContent>
      <DialogActions>
        <CbButton styleName="cancel" onClick={close}>
          Cancel
        </CbButton>
        <CbButton
          styleName="ctaButton"
          onClick={handleDeleteConnector}
          disabled={isSubmitting}
        >
          Confirm
        </CbButton>
      </DialogActions>
    </>
  );
};

export const DeleteConnectorModalConfig = {
  UpdateQuote: {
    component: DeleteConnectorModal,
    config: {
      title: 'Delete Connector',
      fullWidth: true,
      maxWidth: 'sm',
    },
  },
};
